<template>
	<th :style="[styleWidth]" :class="col.cssCellClass">
		<div
			class="flex flex-1 ms-th-content"
			:class="`justify-${col.align == 'right' ? 'end' : col.align}`"
		>
			<span
				@click="sort"
				class="ms-th-title"
				:class="[`text-${col.align}`, col.cssClass]"
				v-tooltip="col.tooltip"
				>{{ col.title }}</span
			>
			<div
				class="mi mi-20 mi-arrow-dropdown"
				:class="[
					{ 'mi-arrow-dropdown': sortStatus == $ms.enum.SortStatus.desc },
					{ 'mi-arrow-up': sortStatus == $ms.enum.SortStatus.asc },
				]"
				v-if="sortStatus != $ms.enum.SortStatus.none"
				@click="sort"
			></div>
			<div class="ms-resize" @mousedown="resizeOn" v-if="resizeCol"></div>
		</div>
	</th>
</template>
<script>
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';

export default {
	name: 'msTh',
	props: {
		col: {},
		data: {},
		resizeCol: {
			default: true,
			type: Boolean,
		},
	},
	created() {
		const me = this;
		me.widthx = me.col._width;
		EventBusGlobal.$on(GlobalEventName.sortEvent, me.remoteSort);
	},
	computed: {
		styleWidth() {
			const me = this;
			let minWidth = me.col._minWidth || me.col._width;
			if (me.col.autoResize) {
				return {
					'min-width': minWidth + 'px',
				};
			}
			return {
				width: me.col._width + 'px',
				'min-width': minWidth + 'px',
			};
		},
	},
	watch: {
		cursorX() {
			const me = this;
			let offsetX = this.resizeX - this.cursorX;
			if (this.defaultwidth - offsetX >= this.minWidthx) {
				this.widthx = this.defaultwidth - offsetX;
			} else {
				this.widthx = this.minWidthx;
			}
			me.$set(me.col, '_width', this.widthx);
			me.$set(me.col, '_minWidth', this.widthx);
		},
	},
	data() {
		return {
			cursorX: 0,
			widthx: 0,
			sortStatus: this.$ms.enum.SortStatus.none,
			// autoResizex: false
		};
	},
	methods: {
		remoteSort(col) {
			const me = this;
			if (me.col != col) {
				me.sortStatus = me.$ms.enum.SortStatus.none;
			}
		},
		sort(e) {
			const me = this;
			EventBusGlobal.$emit(GlobalEventName.sortEvent, me.col);
			me.sortStatus += 1;
			if (me.sortStatus > me.$ms.enum.SortStatus.asc) {
				me.sortStatus = me.$ms.enum.SortStatus.none;
			}
			me.$emit('sort', me.col, me.sortStatus);
		},
		testRender() {},
		//Bắt đầu co kéo cột
		resizeOn(event) {
			const me = this;
			this.$nextTick(() => {
				this.defaultwidth = this.$el.offsetWidth;
				if (!this.minWidthx) {
					this.minWidthx = this.col._minWidth || this.col.width;
				}
			});
			this.resizeX = event.screenX;
			me.$emit('resizeOn', this.col);
			document.addEventListener('mousemove', this.mousemove);
		},
		//Di chuyển co kéo cột
		mousemove(e) {
			const me = this;
			me.cursorX = e.screenX;
			me.$emit('resizeMove', this.col);
			if (!me.isResizeActive) {
				me.isResizeActive = true;
				document.addEventListener('mouseup', me.resizeOff);
			}
		},
		//Ngừng co kéo cột
		resizeOff() {
			const me = this;
			me.$emit('resizeOff', me.col);
			document.removeEventListener('mousemove', me.mousemove);
			me.closeResizeOff();
			me.isResizeActive = false;
		},
		closeResizeOff() {
			document.removeEventListener('mouseup', this.resizeOff);
		},
		//Update lại động rộng của cột
		updateColWidth(autoResize) {
			const me = this;
			if (me.$el) {
				me.minWidth = me.col.width;
				me.$set(me.col, '_width', me.$el.offsetWidth);

				// me.widthx = me.$el.offsetWidth;
				me.$set(me.col, 'autoResize', autoResize);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
</style>